<script setup lang="ts">
export interface RawHtmlBlockProps {
  id: string;
  raw_html: string;
}

defineProps<{
  data: RawHtmlBlockProps;
}>();
</script>
<template>
  <BlockContainer full-width>
    <div class="w-full" v-html="data.raw_html" />
  </BlockContainer>
</template>
